import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-self: flex-start;
  justify-content: left;
  align-items: center;
`
export const Button = styled.button`
  padding: 0.75rem;
  border-radius: 5px;
  margin-left: 0.5rem;
  font-weight: bold;
  background: #2d60ff;
  color: white;
  border: none;
  font-size: 1rem;
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 0.7rem;
  }
`
